// src/pages/GamesListPage.js
import React from 'react';
import GamesList from '../../components/dashboard/GamesList';
import { useNavigate } from 'react-router-dom';

const GamesListPage = () => {
  const navigate = useNavigate();

  const handleGameClick = (gameId) => {
    navigate(`/dashboard/game/${gameId}`); // Redirect to individual game details page
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <GamesList onGameClick={handleGameClick} />  {/* Pass the onGameClick prop */}
    </div>
  );
};

export default GamesListPage;
